import LoginStore from '../ts/stores/LoginStore';
import {Deserialize} from "cerialize";
import Errors from "@/ts/interfaces/Errors";

export const baseURL = process.env.API_URL || "https://baucheck-api.mobivention.eu/api/";

export default abstract class API {

    static getAuth(): string {
        return LoginStore.state.authToken
    }

    static baseRequest(method: string, path: string, data: any): Promise<any> {
        return fetch(baseURL + path, {
            method: method,
            body: data ? JSON.stringify(data) : null,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'X-Auth-Token': API.getAuth()
            }
        }).then(res => {
            return res.json().then(json => {
                if (res.status >= 200 && res.status <= 299) {
                    return json
                } else {
                    throw Deserialize(json, Errors);
                }
            })
        })
    }

    // For requests of FormData
    static upload(data: any, path: string, method: string): Promise<any> {
        return fetch(baseURL + path, {
            method: method,
            body: data,
            headers: {
                Accept: '*/*',
                'X-Auth-Token': API.getAuth()
            }
        }).then(res => {
            return res.json().then(json => {
                if (res.status >= 200 && res.status <= 299) {
                    return json
                } else {
                    throw Deserialize(json, Errors);
                }
            })
        })
    }
}
